import React, { Component } from 'react';

import { 
  DeleteForever 
} from '@mui/icons-material';
import { Fab, Tooltip } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  DisablableOption 
} from "@models";
import { 
  SKILL_OPTIONS,
  SuggestionsOfType
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectSpellBox from "@dndComponents/select/SelectSpellBox";

import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import { DataType } from '@dndModels/Types';

type Props = {
  obj: SuggestionsOfType;
  onChange: (changed: SuggestionsOfType) => void; 
  onDelete: () => void;
  disabled: boolean;
  other_types: string[];
}

export interface State { 
  reloading: boolean;
  obj: SuggestionsOfType;
}

const types: DisablableOption[] = [
  { id: "spell", text: "Spell", disabled: false, reason: "" },
  { id: "cantrip", text: "Cantrip", disabled: false, reason: "" },
  { id: "feat", text: "Feat", disabled: false, reason: "" },
  { id: "skill", text: "Skill Proficiency", disabled: false, reason: "" },
  { id: "expertise", text: "Expertise", disabled: false, reason: "" },
  { id: "tool", text: "Tool Proficiency", disabled: false, reason: "" }
];

const type_map: any = {
  "spell": "Spell",
  "cantrip": "Cantrip",
  "feat": "Feat",
  "skill": "Skill",
  "expertise": "Expertise",
  "tool": "Tool"
};

class SuggestionsOfTypeInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      reloading: false,
      obj: props.obj
    };
  }

  componentDidMount() {
  }

  render() {
    const type = this.state.obj.type;
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 2
          }}>
          <SelectStringBox 
            name="Type"
            options={types.filter(o => this.state.obj.type === o.id || !this.props.other_types.includes(o.id))}
            value={type}
            onChange={(value: DataType) => {
              const obj = this.state.obj;
              obj.type = value;
              obj.ids = [];
              this.setState({ obj, reloading: true }, () => {
                this.props.onChange(obj);
                this.setState({ reloading: false });
              });
            }}
          />
        </Grid>
        { !this.state.reloading ?
          <Grid
            size={{
              xs: 8
            }}>
            { type === "spell" ? 
              <SelectSpellBox
                name={ type_map[type] }
                values={this.state.obj.ids}
                multiple
                onChange={(values: string[]) => {
                  const obj = this.state.obj;
                  obj.ids = values;
                  this.setState({ obj }, () => {
                    this.props.onChange(obj);
                  });
                }}
              />
            // : type === "cantrip" ? 
            //   <SelectSpellBox
            //     name={ type_map[type] }
            //     values={this.state.obj.ids}
            //     // allow_cantrips
            //     level={0}
            //     multiple
            //     onChange={(values: string[]) => {
            //       const obj = this.state.obj;
            //       obj.ids = values;
            //       this.setState({ obj }, () => {
            //         this.props.onChange(obj);
            //       });
            //     }}
            //   />
            // : type === "expertise" ? 
            //   <SelectStringBox
            //     name="Expertise Skills"
            //     options={SKILL_OPTIONS}
            //     values={this.state.obj.ids}
            //     multiple
            //     onChange={(values: string[]) => {
            //       const obj = this.state.obj;
            //       obj.ids = values;
            //       this.setState({ obj }, () => {
            //         this.props.onChange(obj);
            //       });
            //     }}
            //   />
            :
              <SelectObjectBox
                name={ type_map[type] }
                data_type={type}
                values={this.state.obj.ids}
                multiple
                onChange={(values: string[]) => {
                  const obj = this.state.obj;
                  obj.ids = values;
                  this.setState({ obj }, () => {
                    this.props.onChange(obj);
                  });
                }}
              />
            }
          </Grid>
        : 
          <Grid
            size={{
              xs: 8
            }}></Grid>
        }
        <Grid
          size={{
            xs: 2
          }}>
          <Tooltip title={`Delete Type`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                this.props.onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    );
  }
}

export default SuggestionsOfTypeInput;
